import React from "react";
import { MainSurveyStore } from "modules/MainSurveyEditor/hooks/useMainSurvey";
import { SurveyBlocks } from "modules/MainSurveyEditor/surveyBlocks";
import { useBulkRelatedSupportingInfo } from "modules/SupportingInfo/hooks/useBulkRelatedSupportingInfo";
import { RelatedSupportingInfosView } from "./RelatedSupportingInfosView";

interface BulkRelatedSupportingInfosProps {
  mainSurveyStore: MainSurveyStore;
  selectedBlocks: SurveyBlocks.Block[];
  onSaved?: () => void;
}

export const BulkRelatedSupportingInfos = (props: BulkRelatedSupportingInfosProps) => {
  const { mainSurveyStore, selectedBlocks, onSaved } = props;
  const { hasExtra, ...controller } = useBulkRelatedSupportingInfo(selectedBlocks, mainSurveyStore, onSaved);

  return (
    <RelatedSupportingInfosView
      controller={controller}
      hideContentEditing
      extraNote={hasExtra ? "Some selected cells have additional supporting information not shown here." : undefined}
    />
  );
};
